import React, { useEffect } from "react";
import Routes from "./Routes";
import { initGA } from "./utils/analytics";
import { ToastProvider } from "./contexts/ToastContext";

function App() {
  // Initialize Google Analytics on mount
  useEffect(() => {
    initGA();
  }, []);

  return (
    <ToastProvider>
      <Routes />
    </ToastProvider>
  );
}

export default App;
